/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

require('./utils/jquery-extensions');
var $ = require('jquery');
var ajax = require('./utils/ajax');
var urlUtil = require('./utils/url');
var cookies = require('./components/cookie');
var countries = require('./components/country-selection/countries');
var cq = require('./components/tracking/cq');
var minicart = require('./components/header/minicart');
var miniwishlist = require('./components/header/miniwishlist');
var wishlist = require('./pages/wishlist');
var page = require('./components/page');
var breadcrumbs = require('./components/breadcrumbs');
var flyin = require('./flyins/flyin');
var floatingSlider = require('./components/sliders/floatingSlider');
var productSlider = require('./components/product/productSlider');
var flyinscrolling = require('./flyins/flyinscrolling');
var searchinputfield = require('./search/searchinputfield');
var inputfields = require('./utils/inputfields');
var scrolledpage = require('./components/scrolledpage');
var smoothscrolling = require('./utils/smoothscrolling');
var util = require('./utils/util');
var validator = require('./utils/validator');
var uniform = require('./components/uniform');
var carousel = require('./components/carousel');
var legalterms = require('./components/legalterms');
var newsletterfooter = require('./components/footer/newsletterfooter');
var tabNavigation = require('./components/tab-navigation');
var teaser = require('./components/teaser');
var toggle = require('./components/toggle');
var tracking = require('./components/tracking/tracking');
var footbed = require('./footbed/footbed');
var pdpsize = require('./components/product/pdpsize');
var header = require('./components/header/header');
var showpassword = require('./utils/showpassword');
var emojiremove = require('./utils/emojiremove');
var progressbar = require('./utils/progressbar');
var videovimeo = require('./utils/videovimeo');
var lazyload = require('./utils/lazyload');
var lazyloadcss = require('./utils/lazyloadcss');
var offcanvasdialog = require('./components/offcanvasdialog');
var privacy = require('./components/product/privacy');
var privacyOverlay = require('./components/privacy-overlay');
var onsitereturns = require('./components/onsitereturns');
var giftCertificate = require('./components/giftcert');
var crossSell = require('./components/cross-sell');
var cartoverlay = require('./components/checkout/cartoverlay');
var register = require('./components/register');
var authenticitystatement = require('./components/authenticity-statement');
var fitguide = require('./components/product/fitguide');
var stamprally = require('./flyins/stamprally');
var categoryLandingContent = require('./components/categorylandingcontent');
var footerIconsSprite = require('./components/footer/footer-icons-sprite');
var addMaximumScaleToViewport = require('./utils/addMaximumScaleToViewport');
var liveChatPilot = require('./widgets/liveChatPilot');
var geoIpCountrySwitcher = require('./components/geoIpCountrySwitcher');
var cartStickyButton = require('./components/checkout/cartStickyButton');
var checkoutOptiTracking = require('./components/checkout/checkoutOptiTracking');
const privacyPolicy = require('./components/privacy-policy');
const oneTrust = require('./components/oneTrust');
const googleRecaptcha = require('./components/googleRecaptcha');
const universalLink = require('./utils/universalLink');
const recommendationsWidgets = require('./pages/optimizelyRecommendationsWidgets');
const klaviyoListeners = require('./klaviyo/klaviyoListeners');
const {setPrivacyLevelsOneTrust} = require('./components/product/privacy');

import {debounce} from './components/custom-lodash';
import {initConstructorCrossSell} from './constructor-io/helpers/recommendations';

var pages;
var app;

require('./utils/videojs')();
require('inobounce'); // BSDDEV-327 fix scrolling on iOS devices, patch at module needed -> see Webpack config

function initCookiePrivacy(ns) {
    if (SitePreferences.ENABLE_COOKIE_RESTRICTION) {
        if (ns !== 'newsletter' && ns !== 'countryselection') {
            privacy.initPrivacySwitches();
            if (SitePreferences.ENABLE_COOKIE_BANNER) {
                privacyOverlay.initPrivacyOverlay();
            }
        }
    }
}

function initializeEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];
    var $subscribeEmail;

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val());
            var charsLimit = $(this).data('character-limit');
            var charsUsed = text.length;

            if (charsUsed >= charsLimit && controlKeys.indexOf(e.which.toString()) < 0) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text = $.trim($(this).val());
            var charsLimit = $(this).data('character-limit');
            var charsUsed = text.length;
            var charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
        });

    // remove unused content areas
    $('.module-rebrush-grey').each(function () {
        if ($(this).children('.module-rebrush-inner').children().length === 0) {
            $(this).hide();
        }
    });

    $('.applepay-or-message').each(function () {
        if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
            $(this).show();
        }
    });

    // remove isapplepay element if Apple Pay is not available
    if (!window.ApplePaySession) {
        $('isapplepay').remove();
    }

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    //reset cookie settings button
    $('.reset-cookiesettings').click(function () {
        cookies.set('privacy_level', '');
        cookies.set('privacy_settings', '');
        location.reload();
    });

    // add generic tab navigation functionality
    tabNavigation.init();

    // add generic toggle functionality
    toggle.init();

    // add generic teaser functionality
    teaser.init();

    // subscribe email box
    $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0) {
        $subscribeEmail
            .focus(function () {
                var $val = $(this.val());
                if ($val.length > 0 && $val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                    return; // do not animate when contains non-default value
                }

                $(this).animate({color: '#999999'}, 500, 'linear', function () {
                    $(this).val('').css('color', '#333333');
                });
            })
            .blur(function () {
                var val = $.trim($(this.val()));
                if (val.length > 0) {
                    return; // do not animate when contains value
                }
                $(this)
                    .val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                    .css('color', '#999999')
                    .animate({color: '#333333'}, 500, 'linear');
            });
    }

    // main menu toggle
    $('.menu-toggle').on('click', function () {
        $('#wrapper').toggleClass('menu-active');
    });

    $('.menu-category li .menu-item-toggle').on('click', function (e) {
        var $parentLi = $(e.target).closest('li');
        e.preventDefault();
        $parentLi
            .siblings('li')
            .removeClass('active')
            .find('.menu-item-toggle')
            .removeClass('fa-chevron-up active')
            .addClass('fa-chevron-right');
        $parentLi.toggleClass('active');
        $(e.target).toggleClass('fa-chevron-right fa-chevron-up active');
    });

    // set cookie and use this cookie to show/hide very-top-infobanner
    $('.very-infobanner-hide-button button').on('click', function () {
        var $mainWrapper = $('.main-wrapper');
        var $HeaderWrapper = $('.header-wrapper');
        $('.very-infobanner-wrapper').hide();
        $mainWrapper.css('padding-top', $HeaderWrapper.outerHeight());
        cookies.set('dwHideVeryTopInfobanner', true, {path: '/', expires: 30});
    });

    header.init();
    breadcrumbs.init();
    tracking.init();
    onsitereturns.init();

    // Using for content asset find-store
    $('.content-find-store-input input').on('blur', function () {
        if ($(this).val() === '') {
            $('.content-find-store-input .error').show();
        }
    });
    // Using for content asset find-store
    $('.content-find-store-input input').on('keypress', function (e) {
        if (e.which === 13) {
            if ($(this).val() === '') {
                $('.content-find-store-input .error').show();
            } else {
                $('.content-find-store-input .error').hide();
                $('#content-find-store-form').submit();
            }
        } else {
            $('.content-find-store-input .error').hide();
        }
    });
    // Using for content asset find-store
    $('.content-find-store-input span').on('click', function () {
        var $input = $('.content-find-store-input input');
        if ($input.val() === '') {
            $('.content-find-store-input .error').show();
        } else {
            $('.content-find-store-input .error').hide();
            $('#content-find-store-form').submit();
        }
        $('#content-find-store-form').submit();
    });

    // auto complete for japanese zip code and prefection
    $('[data-jpzipcomplete-htmlname]').each(function () {
        require('./components/jpzipcomplete')($(this));
    });

    // handle city-area shipping address dropdown for MEA region
    $('#dropdown-city-shipping').on('change', function () {
        var selectedCityId = $(this).find(':selected').data('city');
        var params = {
            format: 'ajax',
            city: selectedCityId
        };

        var url = urlUtil.appendParamsToUrl(Urls.getAreasByCity, params);

        ajax.load({
            url: url,
            callback: function (data) {
                $('#dropdown-area-shipping').empty().append(data);
            }
        });

        $('#dwfrm_singleshipping_shippingAddress_addressFields_city').val(this.value);
        $('#dwfrm_singleshipping_shippingAddress_addressFields_cityID').val(selectedCityId);
    });

    // handle city-area shipping address dropdown for MEA region
    $('#dropdown-city-billing').on('change', function () {
        var selectedCityId = $(this).find(':selected').data('city');
        var params = {
            format: 'ajax',
            city: selectedCityId
        };

        var url = urlUtil.appendParamsToUrl(Urls.getAreasByCity, params);

        ajax.load({
            url: url,
            callback: function (data) {
                $('#dropdown-area-billing').empty().append(data);
            }
        });

        $('#dwfrm_singleshipping_billingAddress_addressFields_city').val(this.value);
        $('#dwfrm_singleshipping_billingAddress_addressFields_cityID').val(selectedCityId);
    });

    $('#dropdown-area-shipping').on('change', function () {
        $('#dwfrm_singleshipping_shippingAddress_addressFields_cityArea').val(this.value);
    });

    $('#dropdown-area-billing').on('change', function () {
        $('#dwfrm_singleshipping_billingAddress_addressFields_cityArea').val(this.value);
    });

    categoryLandingContent.init();
    footerIconsSprite.init();
    universalLink.init();
}

/**
 * Admin can change content of content slot very-top-header-infobanner. So its height is dynamic
 * Calculate height of header-wrapper and set padding for main-wraper
 */
function changeMainWrapperPadding() {
    var $window = $(window);
    var $HeaderWrapper = $('.header-wrapper');
    var $infoBannerWrapper = $('.very-infobanner-wrapper');
    var $countryGateway = $('.countrygateway');

    function applyPadding() {
        var headerHeight = $HeaderWrapper.outerHeight() - $countryGateway.outerHeight();
        if ($infoBannerWrapper.length) {
            $infoBannerWrapper.css('padding-top', headerHeight);
        }
    }
    $window.on('load', applyPadding);
    $window.on('resize orientationchange', debounce(applyPadding, 10));
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
    // load the off canvas dialog containers
    offcanvasdialog.removeDefaultContainers();
    offcanvasdialog.loadContainers();
}

pages = {
    account: require('./pages/account'),
    login: require('./pages/login'),
    cart: require('./pages/cart'),
    checkout: require('./pages/checkout'),
    // compare: require('./pages/compare'),
    product: require('./pages/product'),
    search: require('./pages/search'),
    storefront: require('./pages/storefront'),
    wishlist: require('./pages/wishlistpage'),
    storelocator: require('./pages/storelocator'),
    customerservice: require('./pages/customerservice'),
    newsletter_signup: require('./pages/newslettersignup'),
    pageelements: require('./pages/pageelements'),
    countryselection: require('./pages/countryselection'),
    newsletteroptout: require('./pages/newsletteroptout'),
    comingsoon: require('./pages/cosmetics/comingsoon'),
    'availability-reminder': require('./pages/availability-reminder')
};

app = {
    init: function () {
        $(function () {
            if ($('.pt_newsletter_confirm .newsletter-confirm-unsubscribe-success').length > 0) {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'newsletterOptOut_page',
                        optOut_reason: sessionStorage.getItem('selectedOption')
                    });
                }
            }
            sessionStorage.removeItem('selectedOption');
        });

        var ns;
        $.extend(page, window.pageContext);
        ns = page.ns;

        if (document.cookie.length === 0) {
            $('<div/>')
                .addClass('no-cookie-message')
                .append($('<div/>').addClass('no-cookie-message-inner').html(Resources.COOKIES_DISABLED))
                .appendTo('#browser-check');
        }
        if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) {
            $('html').addClass('ios');
        }
        if (navigator.appVersion.indexOf('Win') !== -1) {
            $('html').addClass('win-os');
        }

        initializeDom();
        initializeEvents();

        // init specific global components
        initCookiePrivacy(ns);
        emojiremove.init();
        lazyload.init();
        countries.init();
        scrolledpage.init();
        smoothscrolling.init();
        flyinscrolling.init();
        inputfields.init();
        minicart.init();
        miniwishlist.init();
        flyin.init();
        floatingSlider.init();
        productSlider.init();
        searchinputfield.init();
        searchinputfield.faqInit();
        validator.init();
        cq.init();
        carousel.init();
        cartoverlay.init();
        newsletterfooter.init();
        footbed.init();
        pdpsize.init();
        showpassword.init();
        progressbar.init();
        videovimeo.init();
        lazyloadcss.init();
        giftCertificate.init();
        legalterms.init();
        register.init();
        authenticitystatement.init();
        uniform();
        changeMainWrapperPadding();
        addMaximumScaleToViewport.init();
        privacyPolicy.init();
        liveChatPilot.init();
        geoIpCountrySwitcher.init(ns);
        cartStickyButton.init();
        checkoutOptiTracking.init();
        googleRecaptcha.init();
        recommendationsWidgets.init();
        initConstructorCrossSell();
        klaviyoListeners.init();
        setPrivacyLevelsOneTrust();

        window.sgUtil = util;
        oneTrust.init();

        // execute page specific initializations
        if ((!window.location.hash || window.location.hash.indexOf('=') > -1) && ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }

        if (!fitguide.isInitialized() && ($('.fit-guide').length > 0 || $('#cartWarning').length > 0)) {
            fitguide.init();
        }

        if (!stamprally.isInitialized()) {
            stamprally.init();
        }

        // needed for Demandware Predictive Recommendations
        window.dwapp = {
            reportRecommendationLoad: function () {
                lazyload.init();
                wishlist.init();
                carousel.init();
                crossSell.init();
            },
            reportCartRecommendationLoad: function () {
                var is1774 = $('.landing-1774').length > 0;
                lazyload.init();
                if (is1774) {
                    carousel.init();
                } else {
                    cartoverlay.slickRecomm();
                }
                crossSell.init();
            }
        };
    }
};

// enable frontend JS logging
(function () {
    // eslint-disable-next-line no-undef
    if (clientErrorLogging) {
        // eslint-disable-next-line no-undef
        require('./utils/logger')(clientErrorLogging);
    }
})();

// general extension functions
(function () {
    String.format = function () {
        var first = 0;
        var str = arguments[first];
        var i;
        var len = arguments.length - 1;
        var reg;
        for (i = 0; i < len; i++) {
            reg = new RegExp('\\{' + i + '\\}', 'gm');
            str = str.replace(reg, arguments[i + 1]);
        }
        return str;
    };
})();

// initialize app
$(function () {
    app.init();
});
